import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d8fcd9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "navigator",
  ref: "selfRef"
}
const _hoisted_2 = { class: "nav-part nav-left" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "holder",
  style: {"flex":"0 1 5%","min-width":"10px"}
}, null, -1))
const _hoisted_4 = { class: "nav-left-logo" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nav-part nav-center" }, null, -1))
const _hoisted_6 = { class: "nav-part nav-right" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "metaso-search-widget-root",
  style: {"align-self":"center","margin-right":"10px"}
}, null, -1))
const _hoisted_8 = { class: "nav-right-menu" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 产品中心 ")
const _hoisted_10 = { class: "ml-dropdown" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "holder",
  style: {"flex":"0 1 100px","min-width":"10px"}
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MetaLogo = _resolveComponent("MetaLogo")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_MetaLogo, { clickable: true })
      ])
    ]),
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("ul", _hoisted_8, [
        _createElementVNode("li", {
          class: _normalizeClass(["menu-li", {active:_ctx.judgeActivePage('Home')}]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({name:'Home'})))
        }, "主页", 2),
        _createElementVNode("li", {
          class: _normalizeClass(["menu-li position-relative", {active:_ctx.judgeActivePage('Production')}]),
          production: ""
        }, [
          _hoisted_9,
          _createElementVNode("ul", _hoisted_10, [
            _createElementVNode("li", {
              class: _normalizeClass(["m-pd-li", {active:_ctx.judgeActivePage('Metasoai')}]),
              page: "Metasoai",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.proxyRedirect('Metasoai')))
            }, "秘塔AI搜索", 2),
            _createElementVNode("li", {
              class: _normalizeClass(["m-pd-li", {active:_ctx.judgeActivePage('Xiezuocat')}]),
              page: "Xiezuocat",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.proxyRedirect('Xiezuocat')))
            }, "秘塔写作猫", 2),
            _createElementVNode("li", {
              class: _normalizeClass(["m-pd-li", {active:_ctx.judgeActivePage('Interpret')}]),
              page: "Interpret",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.proxyRedirect('Interpret')))
            }, "秘塔翻译", 2),
            _createElementVNode("li", {
              class: _normalizeClass(["m-pd-li", {active:_ctx.judgeActivePage('MetaLaw')}]),
              page: "MetaLaw",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.proxyRedirect('MetaLaw')))
            }, "MetaLaw", 2)
          ])
        ], 2),
        _createElementVNode("li", {
          class: _normalizeClass(["menu-li", {active:_ctx.judgeActivePage('About')}]),
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$router.push({name:'About'})))
        }, "关于秘塔", 2)
      ]),
      _hoisted_11
    ])
  ], 512))
}